// extracted by mini-css-extract-plugin
export default {"Dropzone":"_Dropzone--sqgRA","DashedBorder":"_DashedBorder--axivR","Invalid":"_Invalid--fQCGP","DropzoneErrors":"_DropzoneErrors--CbsUX","HiddenDropzone":"_HiddenDropzone--EZgbQ"};